import { z } from 'zod'

/**
 * Schema for adding tags to a reflection
 * - tagIds: 1-5 tag IDs
 */
export const addTagsSchema = z.object({
  tagIds: z
    .array(z.string().min(1))
    .min(1, 'At least one tag is required')
    .max(5, 'Maximum 5 tags per reflection'),
})

/**
 * Schema for querying system tags
 * - category: optional filter by post type
 */
export const systemTagQuerySchema = z.object({
  category: z.enum(['THEORY', 'CHARACTER', 'THEME']).optional(),
})

export type AddTagsInput = z.infer<typeof addTagsSchema>
export type SystemTagQueryInput = z.infer<typeof systemTagQuerySchema>
